export default __webpack_public_path__ + "static/MediaContentThree-094938f8d1c525051a8f2f038f4b9193.webp";